import {Component} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {MailService} from "../mail.service";
import {AlertComponent} from "../../views/modal/alert.component";
import {PromptComponent} from "../../views/modal/prompt.component";
import {TranslateService} from "../../translate";
import { ModalService } from "../../views/modal/base_modal.component";
import {NotificationsService} from "angular2-notifications";
import {MailerDataReport} from "../../models/mail";
import {FilterComponent} from "./modals/filter.component";
import { FilterParams } from "../../models/filter_form.model";
import { IDataRequestResult } from "../../models/responce_result.model";


interface IMailerResult extends IDataRequestResult{
	ok?: boolean;
	error?: string;
}

@Component({
	template: `<info-modal [title]="title" (onOk)="ok()" [isLoading]="isLoading">
		<table class="table">
			<thead>
				<th>
					id
				</th>
				
				<th>
					{{ 'adminstat.mails.mailer.download name' | translate }}
				</th>
				
				<th>
					Кол-во строк
				</th>
				
				<th>
					{{ 'adminstat.common.Status' | translate }}
				</th>
			
				<th>
					Действия
				</th>
			</thead>
			
			<tbody>
				<tr *ngFor="let report of reports">
					<td>
						{{ report.id }}
					</td>
					
					<td>
						{{ report.name }}
					</td>
					
					<td>
						{{ report.totalCount }}
					</td>
					
					<td>
						<ul class="list-group">
							<li class="list-group-item">
								{{ 'adminstat.common.Date' | translate }}: {{ report.dateCreated }}
							</li>
							
							<li class="list-group-item">
								<b *ngIf="report.dateFinished">
									{{ 'adminstat.mails.mailer.processing done' | translate }}: {{ report.dateFinished }}
								</b>
								
								<p *ngIf="!report.dateFinished">
									<ngb-progressbar
										type="success"
										[showValue]="true"
										[value]="report.totalCount ? (report.count * 100 / report.totalCount).toFixed(0) : 0"
									></ngb-progressbar>
								</p>
							</li>
						</ul>
					</td>
					
					<td>
						<button
							type="button"
							class="btn btn-link"
							[ngClass]="{'fa-disabled': report.count === 0}"
							[title]=" _translate.__A('common.download')"
							(click)="download(report)"
						>
							<i class="fas fa-download"></i>
						</button>
						
						<button
							type="button"
							class="btn btn-link"
							[ngClass]="{'fa-disabled': !report.dateFinished}"
							[title]=" _translate.__A('mails.mailer.to delivery')"
							(click)="sendToMailer(report)"
						>
							<i class="fas fa-share-square"></i>
						</button>

						<button
							type="button"
							class="btn btn-link"
							(click)="showFilterParams(report)"
							title="Параметры"
						>
							<i class="fas fa-filter"></i>
						</button>
						
						<!-- status -->
						<button
							type="button"
							class="btn btn-link"
							(click)="updateReportStatus(report)"
							[title]=" _translate.__A('mails.mailer.status.' + report.status)"
							*ngIf="['wait', 'delayed'].includes(report.status)"
						>
							<i
								class="fas"
								[ngClass]="getMailerReportClasses(report)"
							></i>
						</button>

						<ng-template
							*ngIf="report.status === 'processing'"
						>
							<i class="fas fa-spinner"></i>
						</ng-template>

						<ng-template
							*ngIf="['fail', 'sent_fail'].includes(report.status)"
						>
							<i class="fas fa-exclamation-triangle"></i>
						</ng-template>

						{{ 'adminstat.mails.mailer.status.' + report.status | translate }}
					</td>
				</tr>
			</tbody>
		</table>
	</info-modal>`
})
export class MailerReport extends  InfoModalComponent {
	public reports: MailerDataReport[] = [];
	
	constructor(
		activeModal: NgbActiveModal,
		public modalService: ModalService,
		private _translate: TranslateService,
		private notifications: NotificationsService,
		public mailService: MailService,
	) {
		super(activeModal);
	}
	
	ok() {
		this.close();
	}
	
	
	download(report: MailerDataReport) {
		window.location.href = this.mailService.mailer.downloadFileRoute(
			<FilterParams>{
				name: report.name,
				link: report.link,
			},
			'download'
		);
	}
	
	
	async sendToMailer(report: MailerDataReport) {
		const me = this;
		
		
		// Почему тут проверка на 0, а в основном коде - 9??
		if (report.fields.length === 0) {
			me.modalService.open(AlertComponent, {
				title: 'Внимание!',
				message: 'Выберите хоть один из пунктов "Парметры выборки"'
			});
			
			return ;
		}
		
		const modalRef = me.modalService.open(PromptComponent, {
			title    : me._translate.__A('mails.mailer.enter delivery'),
			question : 'Номер подготовленной в мейлере рассылки должен содержать только цифры'
		});
		
		let deliveryId = '';
		
		modalRef.componentInstance.onChange.subscribe(value => {
			modalRef.componentInstance.errors = [];
			
			if (isFinite(value.trim())) {
				deliveryId = value.trim();
				
				return ;
			}
			
			modalRef.componentInstance.errors.push('Номер подготовленной в мейлере рассылки должен содержать только цифры');
		});
		
		// Ждём закрытия формы
		await modalRef.result;
		
		if ( ! deliveryId || deliveryId === 'c') {
			return ;
		}
		
		// Возможно тут нужно добавить проверку на ввод.
		me.isLoading = true;
		
		const r = await me.mailService.mailer.post<IMailerResult>(
			<FilterParams>{ deliveryId, ...report, }
		).toPromise();
		
		me.isLoading = false;
		
		if (r.ok) {
			me.notifications.info('Пользователей', `Выборка отправлена`, {timeOut: 4000});
		} else {
			me.notifications.error('Пользователей', `Выборка не отправлена`, {timeOut: 4000});
		}
	}
	
	
	async deleteReport(report: MailerDataReport) {
		const me = this;
		
		me.isLoading = true;
		await me.mailService.mailer.delete(<FilterParams>{
			reportId: report.id
		}).toPromise();
		
		me.reports = me.reports.filter(r => r.id !== report.id);
		
		me.isLoading = false;
	}
	
	
	showFilterParams(report: MailerDataReport) {
		const me = this;
		
		me.modalService.open(FilterComponent, {
			title       : report.name,
			filterParams: report.appliedFilterParam,
			sql         : report.query,
		}, {size: 'hg'});
	}
	
	
	async updateReportStatus(report) {
		const newStatus = report.status === 'wait' ? 'delayed' : 'wait';
		
		await this.mailService.mailer.put(
			<FilterParams>{ reportId: report.id, status: newStatus },
			'/report',
		).toPromise();

		report.status = newStatus;
	}
	
	
	getMailerReportClasses(report: MailerDataReport) {
		if (report.status === 'wait') {
			return 'fa-pause';
		}

		if (report.status === 'delayed') {
			return 'fa-play';
		}

		return '';
	}
}
